export default __webpack_public_path__ + "static/media/yt_logo.ba8fd187.svg";